import { useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

const SAVE_BUTTON_SX = {
  width: '100%',
  mt: 5,
} as const;

const FocusTimeDrawerSaveButton = () => {
  const { isLoadingArtifact, isSubmitEnabled, submitForm } = useFormContext();

  return (
    <Button
      variant="contained"
      sx={SAVE_BUTTON_SX}
      disabled={!isSubmitEnabled || isLoadingArtifact}
      onClick={() => submitForm?.()}
    >
      Save
    </Button>
  );
};

export default FocusTimeDrawerSaveButton;
